import React from "react";
import { qr_code } from "../../Images";

const PreviewHtml = () => {
  return (
    <>
      <div className="row">
        <div className="col-sm-4">
          <h2>MHC Kelapa Gading</h2>
          <p>
            PT SMART ELANG FELINDO JLN. BOULEVARD TIMUR BLOK NE1/52 KELAPA
            GADING Telp 4588.4768
          </p>
        </div>
        <div className="col-sm-4"></div>
        <div className="col-sm-2 text-right">
          <h2 style={{ fontSize: 18, fontWeight: "bold" }}>
            No Order : 221000236
          </h2>
          <p>
            Tgl Order : 23 May 2022
            <br />
            Tgl Kirim : 23 May 2022
          </p>
        </div>
        <div className="col-sm-1">
          <img src={qr_code} width={100} />
        </div>
      </div>
      <div className="row justify-content-center">
        <div style={{ fontSize: 24, fontWeight: "bold" }}> INVOICE</div>
      </div>
      <hr />
      <div className="row">
        <div style={{ fontWeight: 500 }}>Ship To:</div>
      </div>
      <div className="row" style={{ paddingBottom: 10 }}>
        <table width={300}>
          <tr>
            <td>Nama</td>
            <td style={{ paddingLeft: 5, paddingRight: 5 }}>:</td>
            <td>Ibu Vony</td>
          </tr>
          <tr>
            <td style={{ verticalAlign: "top" }}>Address</td>
            <td
              style={{ verticalAlign: "top", paddingLeft: 5, paddingRight: 5 }}
            >
              :
            </td>
            <td>
              FORTUNE ESSENCE D3/D26 GRAHA RAYA RT.006/RW.007 TAJUR. CILEDUG,
              KOTA TANGERANG
            </td>
          </tr>
          <tr>
            <td>Telepon</td>
            <td style={{ paddingLeft: 5, paddingRight: 5 }}>:</td>
            <td>08161469090</td>
          </tr>
        </table>
      </div>
      <div className="row">
        <table className="table">
          <thead>
            <tr>
              <td>NO</td>
              <td>Product</td>
              <td>Quantity</td>
              <td>Unit/Price</td>
              <td>Discount</td>
              <td>Final Price</td>
              <td>Total</td>
            </tr>
          </thead>
          <tbody>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
              }}
            >
              <td style={{ borderTop: "none" }}>1</td>
              <td style={{ borderTop: "none" }}>
                MODENA GAS HOB - BH 0725 (SKU2199903)
              </td>
              <td style={{ borderTop: "none" }}>10</td>
              <td style={{ borderTop: "none" }}>1.500.000</td>
              <td style={{ borderTop: "none" }}>150.000</td>
              <td style={{ borderTop: "none" }}>1.350.000</td>
              <td style={{ borderTop: "none" }}>1.350.000</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
              }}
            >
              <td style={{ borderTop: "none" }}>2</td>
              <td style={{ borderTop: "none" }}>
                MODENA GAS HOB - BH 0725 (SKU2199903)
              </td>
              <td style={{ borderTop: "none" }}>10</td>
              <td style={{ borderTop: "none" }}>1.500.000</td>
              <td style={{ borderTop: "none" }}>150.000</td>
              <td style={{ borderTop: "none" }}>1.350.000</td>
              <td style={{ borderTop: "none" }}>1.350.000</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
                borderBottom: "none",
              }}
            >
              <td style={{ borderTop: "none" }} colSpan={4}></td>
              <td style={{ borderTop: "none", textAlign: "right" }} colSpan={2}>
                Total Price
              </td>
              <td style={{ borderTop: "none" }}>2.800.000</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
                borderTop: "none",
                borderBottom: "none",
              }}
            >
              <td style={{ borderTop: "none" }} colSpan={4}></td>
              <td style={{ borderTop: "none", textAlign: "right" }} colSpan={2}>
                Diskon 10%
              </td>
              <td style={{ borderTop: "none" }}>2.800.000</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
                borderTop: "none",
                borderBottom: "none",
              }}
            >
              <td style={{ borderTop: "none" }} colSpan={4}></td>
              <td style={{ borderTop: "none", textAlign: "right" }} colSpan={2}>
                PPN
              </td>
              <td style={{ borderTop: "none" }}>0</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
                borderTop: "none",
                borderBottom: "none",
              }}
            >
              <td style={{ borderTop: "none" }} colSpan={4}></td>
              <td style={{ borderTop: "none", textAlign: "right" }} colSpan={2}>
                PPH
              </td>
              <td style={{ borderTop: "none" }}>0</td>
            </tr>
            <tr
              style={{
                borderStyle: "solid",
                borderColor: "GrayText",
                borderWidth: 1,
                borderTop: "none",
              }}
            >
              <td style={{ borderTop: "none" }} colSpan={4}></td>
              <td style={{ borderTop: "none", textAlign: "right" }} colSpan={2}>
                Grand Total
              </td>
              <td style={{ borderTop: "none" }}>2.800.000</td>
            </tr>
          </tbody>
        </table>
        <div style={{ fontSize: 18, fontWeight: 500 }}>
          Terbilang : Dua puluh lima juta lima ratus ribu Rupiah
        </div>
        <div className="row" style={{ padding: 10 }}>
          <div className="">
            <div className="note">
              Dokumen ini bukan merupakan bukti transaksi, silakan melakukan
              pembayaran terlebih dahulu. Pembayaran yang dilakukan melalui
              sistem kami akan dianggap sah apabila memenuhi syarat-syarat
              berikut:
              <ul>
                <li style={{ marginTop: "10px" }}>
                  <b>Kartu Kredit atau Kartu Debit:</b>
                </li>
                Transaksi menggunakan Kartu Kredit atau Kartu Debit dianggap sah
                jika mengunakan mesin EDC yang tersedia pada MHC Store.
                <li style={{ marginTop: "10px" }}>
                  <b>Payment Transfer Bank: </b>
                </li>
                Pembayaran menggunakan Payment Gateway(Xendit). yang akan
                mengirimkan link payment melalu WA/Email yang bisa anda transfer
                dan akan di verifikasi oleh payment gateway. Customer akan
                menerima email berupa INOVICE sebagai bukti transaksi setelah
                pembayaran terverifikasi oleh system
              </ul>
            </div>
          </div>

          <ul>
            <li>
              Kami tidak bertanggung jawab terhadap apapun jika pembeli
              melakukan pembayaran di luar rekening tersebut.
            </li>
            <li>
              Pemasangan/instalasi hanya dapat dilaksanakan minimal 1 (satu)
              hari setelah pengiriman.
            </li>
            <li>
              Pengiriman barang ke konsumen dilakukan maksimal dalam waktu 7
              (tujuh) hari.
            </li>
            <li>
              Data-data tersebut di atas telah diperiksa dan disetujui oleh
              pembeli.
            </li>
            <li>
              Informasi lebih lanjut dapat menghubungi Nationwide Call Center
              1500715
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default PreviewHtml;
